export default __webpack_public_path__ + "static/media/es.628f10fe.svg";